import { useAuth } from '@/lib/auth-context';
import SocialShell from '@/components/social/SocialShell';
import { combineTheme } from '@/components/social/themes';

const COACH_ROLES = new Set(['coach', 'admin', 'superadmin']);

export default function TheCombine() {
  const { role } = useAuth();
  const canPost = COACH_ROLES.has(role || '');

  return <SocialShell clubId="the-combine" theme={combineTheme} canPost={canPost} />;
}
